import { calcDate } from "@/util/date.js";
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 5,
    searchMenuSpan: 4,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "进件编号",
            prop: "businessCode",
            type: "input",
            search: true,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: true,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            type: "input",
            search: false,
        },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        // {
        //     label: "状态",
        //     prop: "sectionStatus",
        //     type: "select",
        //     dicData: [{
        //             label: "诉讼中",
        //             value: 0,
        //         },
        //         {
        //             label: "已诉讼",
        //             value: 1,
        //         },
        //         {
        //             label: "已调解",
        //             value: 2,
        //         },
        //         {
        //             label: "已判决",
        //             value: 3,
        //         },
        //         {
        //             label: "委托第三方",
        //             value: 4,
        //         },
        //     ],
        // },
        {
            label: "一审法院",
            prop: "firstInstanceCourt",
            type: "input",
        },
        // {
        //     label: "案件进展",
        //     prop: "caseProgress",
        //     type: "input",
        // },
        {
            label: "租赁金额",
            prop: "lendingAmount",
            hide: false,
            type: "input",
        },
        {
            label: "标的额",
            prop: "targetAmount",
            hide: false,
            type: "input",
        },
        {
            label: "滞留时间",
            hide: false,
            prop: "createTime",
            type: "input",
            formatter: (val, value, label) => {
                if (!value) return ''
                const date = calcDate(new Date(value).getTime(), new Date().getTime());
                return `${date.days}天${date.hours}小时${date.minutes}分`;
            }
        },
    ],
};
